import type { ChatRoom } from 'models';
import type { User } from 'features/auth';

type ChatPermissionParams = {
  chatroom: ChatRoom;
  viewer: User;
};

const isChatroomAuthor = ({
  chatroom: { author },
  viewer: {
    nodeUserData: { _id },
  },
}: ChatPermissionParams) => author === _id;

export const canAddChatMember = ({ chatroom, viewer }: ChatPermissionParams) => isChatroomAuthor({ chatroom, viewer });

export const canDeleteChat = ({ chatroom, viewer }: ChatPermissionParams) => isChatroomAuthor({ chatroom, viewer });

export const canRemoveChatMember = ({
  chatroom,
  memberUserId,
  viewer,
}: { memberUserId: string } & ChatPermissionParams) =>
  isChatroomAuthor({ chatroom, viewer }) && memberUserId !== viewer.nodeUserData._id;

export const canRenameChat = ({ chatroom, viewer }: ChatPermissionParams) => isChatroomAuthor({ chatroom, viewer });
